import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import {
  SectionHeading,
  Subheading as SubheadingBase,
} from "../misc/Headings.js";
import Navbarlogedin from "./Navbarlogedin";
import { TextField, Button, Grid } from "@mui/material";
import { Helmet } from "react-helmet";
import axios from "axios"
// import EmailIllustrationSrc from "../../images/email-illustration.svg";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import "./CompletedInterviews.css";
import UpcomingInterview from "./cards/UpcomingInterview"
const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const TextColumn = styled(Column)((props) => [
  tw`md:w-7/12 mt-16 md:mt-0`,
  props.textOnLeft
    ? tw`md:mr-12 lg:mr-16 md:order-first`
    : tw`md:ml-12 lg:ml-16 md:order-last`,
]);

const TextContent = tw.div`lg:py-8 text-center md:text-left`;

const Subheading = tw(SubheadingBase)`text-center md:text-left`;
const Heading = tw(
  SectionHeading
)`mt-4 font-black text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Description = tw.p`mt-4 text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100`;
const Description2 = tw.p`mt-4 text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-red-700`;

const Issue = (userDetails) => {
  const user = userDetails.user;
  const [state, setState] = React.useState({
    one: false,
    two: false,
    three: false,
    four: false,
    five: false,
    six: false,
  });

  const handleChangeCheckBox = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
  };

  const { one, two, three, four, five, six } = state;
  const subheading = "",
    heading = (
      <>
        <span tw="text-changed-100">Report an Issue</span>
        <wbr />
      </>
    ),
    description =
      "Please Enter your Mock Interview ID and then proceed to report your issue.",
    textOnLeft = true;
  // The textOnLeft boolean prop can be used to display either the text on left or right side of the image.
  const arr = [];
  const [inputs, setInputs] = React.useState({
    idVerify: "",
  });
  const [data, setData] = React.useState({
    textofArea: "",
  });
  const handleChangeofBox = (e) => {
    const value = e.target.value;
    setData({
      ...data,
      [e.target.name]: value,
    });
  };
  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs({ ...inputs, [name]: value });
  };

  const [cards,setCards]=React.useState(null)
  async function fetchData() {
    console.log(inputs.idVerify);
    console.log("id");
     if(inputs.idVerify===""){
      window.alert("Please enter a valid Mock Interview ID")
      window.scrollTo(0, 0);
       return
     }
    const req = await axios.get(
      `${process.env.REACT_APP_SERVER_URL}/api/get/${inputs.idVerify}`
    ).then((response) => {
      setCards(response.data)
    localStorage.setItem("details",JSON.stringify(response.data))
    console.log(JSON.parse(localStorage.getItem("details")).toname)
    }).catch((error) => {
      window.alert("Please enter a valid Mock Interview ID")
      window.scrollTo(0, 0);
      console.error(error);
    })
    
  }
  return (
    <>
      <Helmet>
        <title>Interwiu | Report an Issue</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      <Navbarlogedin />
      <Container>
        <TwoColumn>
          <TextColumn textOnLeft={textOnLeft}>
            <TextContent>
              {subheading && <Subheading>{subheading}</Subheading>}
              <Heading>{heading}</Heading>
              <Description2>
                You can report an issue about this mock interview anytime upto
                5:00 pm, 25 July 2020
              </Description2>
              {/* <Description2>Time Limit of Reporting an Issue about this Mock Interview has expired! You could report it only upto 24 hours after this mock interview’s time-slot</Description2> */}
              {description && <Description>{description}</Description>}
            </TextContent>
            <Grid container spacing={1}>
              <Grid item xs={3}>
                <TextField
                  type="text"
                  name="idVerify"
                  className="border-2 rounded"
                  value={inputs.idVerify}
                  onChange={handleChange}
                  placeholder="Last Name"
                />
                <Button onClick={fetchData}>Verify</Button>
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid item xs={6}>
                <h5>Details of your Mock Interview</h5>
                {cards &&
                <UpcomingInterview
                    name={JSON.parse(localStorage.getItem("details")).toname}
                  //  desg={result.desg}
                    profile={JSON.parse(localStorage.getItem("details")).profile}
                    price={JSON.parse(localStorage.getItem("details")).price}
                    slot={JSON.parse(localStorage.getItem("details")).slot}
                    status={JSON.parse(localStorage.getItem("details")).status}
                    payment={JSON.parse(localStorage.getItem("details")).payment}
                    id={JSON.parse(localStorage.getItem("details"))._id}
                    logo={require("../../images/amazon.png")}
                />
              }
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ mt: 2 }}>
              <FormControl
                sx={{ m: 3 }}
                component="fieldset"
                variant="standard"
              >
                <FormLabel component="legend">
                  Please Check the issues you faced
                </FormLabel>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={one}
                        onChange={handleChangeCheckBox}
                        name="one"
                      />
                    }
                    label="Interviewer did not join for the mock interview at all"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={two}
                        onChange={handleChangeCheckBox}
                        name="two"
                      />
                    }
                    label="Interviewer joined late by more than 15 minutes for the mock interview but left on time"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={three}
                        onChange={handleChangeCheckBox}
                        name="three"
                      />
                    }
                    label="Interviewer was unprofessional"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={four}
                        onChange={handleChangeCheckBox}
                        name="four"
                      />
                    }
                    label="Structure of mock interview was not as per the real interviews   "
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={five}
                        onChange={handleChangeCheckBox}
                        name="five"
                      />
                    }
                    label="Interviewer focused more on mentoring and guidance, rather asking the interview-questions"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={six}
                        onChange={handleChangeCheckBox}
                        name="six"
                      />
                    }
                    label="Other Issues"
                  />
                  <TextField
                    ype="text"
                      name="textofArea"
                      label="Describe your issue(s) in detail"
                      multiline
                      rows={4}
                      sx={{ mt: 2 }}
                      value={data.textofArea}
                    onChange={handleChangeofBox}
                  />
                </FormGroup>
              </FormControl>
            </Grid>

            <Grid item sx={{ mt: 2, mb: 2 }}>
              <Button variant="contained" onClick={() => {
                      const checking=JSON.stringify(state)
                      if(JSON.parse(state.one)===false && JSON.parse(state.two)===false && JSON.parse(state.three)===false && JSON.parse(state.four)===false && JSON.parse(state.five)===false && JSON.parse(state.six)===false){
                        window.alert("Please select Atleast one reason")
                        window.scrollTo(0, 0);
                        return
                      }
                      const obj = {
                        reported: true,
                        reportReasonAuto: checking,
                        reportReasonManual:data.textofArea,
                        reporterType:JSON.parse(localStorage.getItem("isAuthenticated")).role
                      };
                      axios
                        .patch(
                          `${process.env.REACT_APP_SERVER_URL}/api/edit/${inputs.idVerify}`,
                          obj
                        )
                        .then((response) => {
                          console.log(response.status);
                          console.log(response.data);
                          window.alert("Are you sure?");
                        }).catch((error)=>{
                          window.alert("Please enter a valid Mock Interview Id");
                          window.scrollTo(0, 0);
                        })
                    }}>Report the Issue</Button>
            </Grid>
          </TextColumn>
        </TwoColumn>
      </Container>
    </>
  );
};
export default Issue;
